// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import toast, {Toaster} from 'react-hot-toast';

export function Root(){
    return <Toaster/>;
}

export const spawn = toast;
